import { render, staticRenderFns } from "./CloseBoxAdmin.vue?vue&type=template&id=523f14ba&"
import script from "./CloseBoxAdmin.vue?vue&type=script&lang=js&"
export * from "./CloseBoxAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports